import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FC } from 'react';

type GraphicRequestedModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};
const GraphicRequestedModal: FC<GraphicRequestedModalProps> = ({
  isOpen,
  handleClose,
}) => {
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Custom Graphic Requested!</DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <Alert
            severity="success">Request Sent!</Alert>
          <Typography>
            We'll have your graphic professionally designed and added to your
            account within 24-48 hours.
          </Typography>
          <Button
            variant="contained" color="success" onClick={handleClose}>
            OK!
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default GraphicRequestedModal;
